<div class="filter-row">
  <div class="filter-left">
    <search-type typ="de" [current]="currentSearchType()" (update)="updateSearchType($event)"></search-type>
    <search-type typ="cn" [current]="currentSearchType()" (update)="updateSearchType($event)"></search-type>

    <button class="btn btn-info btn-sm" type="button" (click)="badge('noinvoice')"
      [ngClass]="{active: q('noinvoice')}">
      Ohne Rechnung
    </button>
    <button class="btn btn-warning btn-filter" type="button" (click)="badge('1')" [ngClass]="{active: q('1')}">
      Aktive <span class="badge">{{ list.badges.delivered }}</span>
    </button>

    <button class="btn btn-default btn-filter" type="button" (click)="badge('4')" [ngClass]="{active: q('4')}">
      Gesperrt <span class="badge">{{ list.badges.locked }}</span>
    </button>

    <button class="btn btn-default btn-sm" type="button" (click)="badge('2')" [ngClass]="{active: q('2')}">
      Inaktive
    </button>

    <button class="btn btn-default btn-filter" type="button" (click)="badge('all')" [ngClass]="{active: q('all')}">
      Alle <span class="badge">{{ list.badges.all }}</span>
    </button>

    @if (('delivery.export'|HasPerm)) {
      <ev-file-button [url]="downloadUrl('/workflow/v1/delivery/export/')" [link]="false">
        <i class="fa fa-download"></i>
      </ev-file-button>
    }
  </div>

  <div class="filter-right">
    <date-range [start]="null" [end]="null" (update)="updateDateRange($event)"></date-range>
  </div>
</div>

<form #changeForm="ngForm" name="form">
  <table class="table whitetable">
    <thead>
      <tr>
        <th>
          <a (click)="sort($event, 'id', 'ASC')" [href]="sortUrl('id', 'ASC')">
            Lieferschein
          </a>
        </th>
        <th>
          <a (click)="sort($event, 'workflow_id', 'ASC')" [href]="sortUrl('workflow_id', 'ASC')">
            Vorgang
          </a>
        </th>
        <th>&nbsp;</th>
        <th>
          <a (click)="sort($event, 'date', 'ASC')" [href]="sortUrl('date', 'ASC')">
            Datum
          </a>
        </th>
        <th>
          <a (click)="sort($event, 'sds_nr', 'ASC')" [href]="sortUrl('sds_nr', 'ASC')">
            SDS-Nr.
          </a>
        </th>
        <th>
          <a (click)="sort($event, 'quanity', 'ASC')" [href]="sortUrl('quanity', 'ASC')">
            Stückzahl
          </a>
        </th>
        <th>
          <a (click)="sort($event, 'oa_nr', 'ASC')" [href]="sortUrl('oa_nr', 'ASC')">
            0A-Nr.
          </a>
        </th>
        <th>
          <a (click)="sort($event, 'kd_art_nr', 'ASC')" [href]="sortUrl('kd_art_nr', 'ASC')">
            Kd-Art-Nr.
          </a>
        </th>
        <th>
          <a (click)="sort($event, 'customer_name', 'ASC')" [href]="sortUrl('customer_name', 'ASC')">
            Kunde
          </a>
        </th>
        <th>
          <a (click)="sort($event, 'customer_zip', 'ASC')" [href]="sortUrl('customer_zip', 'ASC')">
            PLZ
          </a>
        </th>
        <th>
          <a (click)="sort($event, 'customer_city', 'ASC')" [href]="sortUrl('customer_city', 'ASC')">
            Stadt
          </a>
        </th>
        <th>
          <a (click)="sort($event, 'customer_country', 'ASC')" [href]="sortUrl('customer_country', 'ASC')">
            Land
          </a>
        </th>
        <th>
          <a (click)="sort($event, 'customer_field_service', 'ASC')" [href]="sortUrl('customer_field_service', 'ASC')">
            Vertriebsgebiet
          </a>
        </th>
        <th>
          <a (click)="sort($event, 'username', 'ASC')" [href]="sortUrl('username', 'ASC')">
            Ersteller
          </a>
        </th>
        <th colspan="6"></th>
      </tr>
      <tr class="filterrow">
        <th>
          <input type="text"
            class="form-control input-sm"
            name="sid"
            [ngClass]="{'red_alert': filterFormErrors.sid}"
            [(ngModel)]="data.sid"
            [autofocus]
            autocomplete="off search-delivery-id">
        </th>
        <th>
          <input type="text"
            class="form-control input-sm"
            name="workflow_id"
            [ngClass]="{'red_alert': filterFormErrors.workflow_id}"
            [(ngModel)]="data.workflow_id">
        </th>
        <th>&nbsp;</th>
        <th>&nbsp;</th>
        <th>
          <input type="text"
            class="form-control input-sm"
            name="sds_nr"
            [ngClass]="{'red_alert': filterFormErrors.sds_nr}"
            [(ngModel)]="data.sds_nr">
        </th>
        <th>
          <input type="text"
            class="form-control input-sm"
            name="quanity"
            [ngClass]="{'red_alert': filterFormErrors.quanity}"
            [(ngModel)]="data.quanity">
        </th>
        <th>
          <input type="text"
            class="form-control input-sm"
            name="oa_nr"
            [ngClass]="{'red_alert': filterFormErrors.oa_nr}"
            [(ngModel)]="data.oa_nr">
        </th>
        <th>
          <input type="text"
            class="form-control input-sm"
            name="kd_art_nr"
            [ngClass]="{'red_alert': filterFormErrors.kd_art_nr}"
            [(ngModel)]="data.kd_art_nr">
        </th>
        <th>
          <input type="text"
            class="form-control input-sm"
            name="customer_name"
            [ngClass]="{'red_alert': filterFormErrors.customer_name}"
            [(ngModel)]="data.customer_name">
        </th>
        <th>
          <input type="text"
            class="form-control input-sm"
            name="customer_zip"
            [ngClass]="{'red_alert': filterFormErrors.customer_zip}"
            [(ngModel)]="data.customer_zip">
        </th>
        <th>
          <input type="text"
            class="form-control input-sm"
            name="customer_city"
            [ngClass]="{'red_alert': filterFormErrors.customer_city}"
            [(ngModel)]="data.customer_city">
        </th>
        <th>
          <input type="text"
            class="form-control input-sm"
            name="customer_country"
            [ngClass]="{'red_alert': filterFormErrors.customer_country}"
            [(ngModel)]="data.customer_country">
        </th>
        <th>
          <input type="text"
            class="form-control input-sm"
            name="customer_field_service"
            [ngClass]="{'red_alert': filterFormErrors.customer_field_service}"
            [(ngModel)]="data.customer_field_service">
        </th>
        <th>
          <input type="text"
            class="form-control input-sm"
            name="username"
            [ngClass]="{'red_alert': filterFormErrors.username}"
            [(ngModel)]="data.username">
        </th>
        <th colspan="6">&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      @for (object of list.objects; track object; let index = $index) {
        <tr>
          <td>
            <ev-file-button [objId]="object.id" type="delivery">{{ object.id }}</ev-file-button>
            @if (object.typ === 'cn') {
              <img src="/ui/assets/images/flags/cn.png">
            }
            @if (object.typ === 'de') {
              <img src="/ui/assets/images/flags/de.png">
            }
            @if (object.storno) {
              <span class="label label-danger">Storniert</span>
            }
            @if (object.delivery_invoice_lock && !object.storno) {
              <span class="label label-default">Gesperrt</span>
            }
            @if (object.delivery_invoice_id && !object.storno && !object.delivery_invoice_lock) {
              <span class="label label-success"
                >
                Abgerechnet
              </span>
            }
            @if (!object.delivery_invoice_id && !object.storno && !object.delivery_invoice_lock) {
              <span class="label label-warning"
                >
                Geliefert
              </span>
            }
          </td>
          <td>
            <a uiSref="a.workflow.detail" [uiParams]="{id: object.workflow_id}">
              {{ object.workflow_id }}
              @if (object.comments > 0) {
                <span class="td-comments" title="Kommentar(e) vorhanden">
                  <i class="fa fa-comments"></i>
                </span>
              }
            </a>
          </td>
          <td>
            @if (object.status >= 100) {
              <ev-status-label type="workflow_status" [state]="object.status"></ev-status-label>
            }
          </td>
          <td>{{ object.date }}</td>
          <td>
            <strong>{{ object.sds_nr }}</strong>
          </td>
          <td>{{ object.quanity }}</td>
          <td>{{ object.oa_nr }}</td>
          <td>
            {{ object.kd_art_nr }}
            @if (object.kd_art_index) {
              <span class="label label-default">{{ object.kd_art_index }}</span>
            }
          </td>
          <td>
            <span [ngbTooltip]="object.customer_name">
              {{ object.customer_name|limitTo: 30 }}
            </span>
          </td>
          <td>{{ object.customer_zip }}</td>
          <td>{{ object.customer_city }}</td>
          <td>{{ object.customer_country }}</td>
          <td>{{ object.customer_field_service }}</td>
          <td><a [href]="'mailto:' + object.email">{{ object.username }}</a></td>
          <td>&nbsp;</td>
          <td>
            @if ('price.detail'|HasPerm) {
              <a class="btn btn-default btn-sm" uiSref="a.price.check" [uiParams]="{id: object.oa_nr}"
                >
                Prüfung
              </a>
            }
          </td>
          <td>
            <button type="button"
                    class="btn btn-default btn-sm"
                    (click)="cocMaterialChange(object)">
              <i class="fa fa-cog"></i>
            </button>
          </td>
          <td>
            <ev-file-button [hawk]="true"
              [hawkUrl]="documentDownload(object, 'coc')"
              [link]="false"
              [disabled]="!object.has_shipping_instructions">
              COC
            </ev-file-button>
          </td>
          <td>
            <ev-file-button [hawk]="true"
              [hawkUrl]="documentDownload(object, 'konform')"
              [link]="false"
              [disabled]="!object.has_shipping_instructions">
              Konf
            </ev-file-button>
          </td>
          <td>
            <ev-file-button [hawk]="true"
              [hawkUrl]="documentDownload(object, 'werk')"
              [link]="false"
              [disabled]="!object.has_shipping_instructions">
              Werk
            </ev-file-button>
          </td>
        </tr>
      }
    </tbody>
  </table>
</form>

<ev-navigation [page]="list.page" [pages]="list.pages" [query]="query()" (goto)="goto($event)"></ev-navigation>
